import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import StreamgraphChart from './components/StreamgraphChart'
import VariantCovidCluster from './components/VariantCovidCluster'
import VariantCovidSequences from './components/VariantCovidSequences'
import { HeaderChartProps, mainSeason, modalSeason, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import VariantCovidEvolutionByChain from './components/VariantCovidEvolutionByChain'
import SourceLink from '../../component/chartLinkData'

interface ItemType {
  id: number
  title: string
  campaigns: number
  logo: string
  bgColor: string
}

const DashboardPage = () => {
  const [showSeasonModal, setShowSeasonModal] = useState(false)
  const [selectedAgeClass, setSelectedAgeClass] = useState<string[]>(['0-200'])

  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const HeaderChart = ({ season }: HeaderChartProps) => (
    <h2 className='text-primary bold'>
      {' '}
      Covid-19 - Positivity rate among samples tested {season} (France - Lyon){' '}
      <OverlayTrigger
        placement='right'
        overlay={
          <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
            <p>
              The graph shows the number of samples tested and the positivity rate for
              Influenza, SARS-CoV2, RSV and other respiratory viruses over the last
              week. Virological data are provided on a weekly basis by the Laboratoire
              de Biologie Médicale Multi Sites (LBMMS) from the Hospices Civils de Lyon.
              Data are available per respiratory virus and per age group (source BEHcl).
            </p>
          </Tooltip>
        }
      >
        <img
          style={{ width: '12px', marginLeft: '10px' }}
          alt='logo'
          src={toAbsoluteUrl('/media/logos/ii.svg')}
        />
      </OverlayTrigger>
      {/* <i
                    style={{color: 'green', marginLeft: '10%', fontSize: '20px'}}
                    className='  fa-solid fa-arrow-down '
                  ></i> */}
    </h2>
  )

  return (
    <>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row g-5 g-xl-8'>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <HeaderChart season={null} />
              </div>
              <Card.Body className='row' style={{ marginTop: '-35px' }}>
                <StreamgraphChart
                  season={mainSeason}
                  selectedAgeClass={selectedAgeClass}
                  setSelectedAgeClass={setSelectedAgeClass}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <p className='card-text source'>
                    <i>
                      Source:
                      <a className='fw-bold' href='https://www.chu-lyon.fr'>
                        {' '}
                        Hospices Civils de Lyon
                      </a>{' '}
                      , BEHcl
                    </i>{' '}
                  </p>
                  <SourceLink onClick={() => setShowSeasonModal(true)} />
                </div>
              </Card.Body>
            </div>
          </Card>
        </div>
      </div>
      <Modal
        // size="xl"
        className="modal-xxl"
        show={showSeasonModal}
        onHide={() => setShowSeasonModal(false)}
        centered
      >
        <Modal.Header closeButton className='py-4'>
          <Modal.Title className='bold'>
            <HeaderChart season={'2023-2024'} />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body >
          <StreamgraphChart
            season={modalSeason}
            selectedAgeClass={selectedAgeClass}
            setSelectedAgeClass={setSelectedAgeClass}
          />
          <div className="d-flex justify-content-between align-items-center">
            <p className='card-text source'>
              <i>
                Source:
                <a className='fw-bold' href='https://www.chu-lyon.fr'>
                  {' '}
                  Hospices Civils de Lyon
                </a>{' '}
                , BEHcl
              </i>{' '}
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

const DashboardPage1 = () => {
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row g-5 g-xl-8'>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <h2 className='text-primary bold'>
                  {' '}
                  GISAID sequences analysis – Evolution of Covid-19 variants (France){' '}
                  <OverlayTrigger
                    placement='right'
                    overlay={
                      <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
                        <p>
                          The analysis is based on Gisaid repository of Covid-19 virological
                          sequences for France and allows early detection of emerging Covid-19
                          variants. Sequences are retrieved and processed weekly. The method relies
                          on unsupervised time-ordered clustering analysis of spike protein
                          sequences and allows to group weekly reported sequences into clusters
                          based on the Levenshtein distance. Weekly clusters are further regrouped
                          into chains according to the level of proximity between clusters
                          identified during successive weeks.
                        </p>
                      </Tooltip>
                    }
                  >
                    <img
                      style={{ width: '12px', marginLeft: '10px' }}
                      alt='logo'
                      src={toAbsoluteUrl('/media/logos/ii.svg')}
                    />
                  </OverlayTrigger>
                  {/* <i
                    style={{color: 'green', marginLeft: '10%', fontSize: '20px'}}
                    className='  fa-solid fa-arrow-down '
                  ></i> */}
                </h2>
              </div>
              <Card.Body className='row' style={{ marginTop: '-35px' }}>
                <VariantCovidSequences />
                <p className='card-text source mt-2'>
                  <i>
                    Source:
                    <a className='fw-bold' href='https://gisaid.org/'>
                      {' '}
                      GISAID
                    </a>
                  </i>{' '}
                </p>
              </Card.Body>
              <Card.Body className='row'>
                <VariantCovidCluster />
              </Card.Body>
              <Card.Body className='row'>
                <VariantCovidEvolutionByChain />
                <p className='card-text source mt-2'>
                  <i>
                    Source:
                    <a className='fw-bold' href='https://www.sdu.dk/en/forskning/quantum-field-theory-center/complex-systems'>
                      {' '}
                      Model developed by IP2I Lyon
                    </a>{' '}
                    , CNRS
                  </i>{' '}
                </p>
              </Card.Body>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}
const Covid = () => {
  const intl = useIntl()
  return (
    <>
      <div className='mb-5'>
        <DashboardPage />
      </div>
      {/* <div className='mb-5'>
        <DashboardPage1 />
      </div> */}
    </>
  )
}

export { Covid }
